import React, { memo } from "react";

export const PrevPageButton = memo((props) => {
  const { text, onClick } = props;

  return (
    <>
      <button 
        type="button"
        name="testName"
        value="testValue"
        className="btn btn-outline-secondary btn-lg w-100 mb-3"
        onClick={onClick}
      >
        <i className="fas fa-chevron-left"></i> {text}
      </button>
    </>
  );
});